import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.support.module.diagnosis');
import { OnInit, OnChanges, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare const wiz: any;

@Component({
    selector: 'wiz-portal-lpsysadmin-support-module-diagnosis',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/portal.lpsysadmin.support.module.diagnosis/view.scss */
:host {
  display: block;
}`],
})
export class PortalLpsysadminSupportModuleDiagnosisComponent implements OnInit, OnChanges {
    @Input() program_id: string = '';
    @Input() module_id: string = '';

    constructor(@Inject( Service) public service: Service) { }

    public loaded: boolean = false;
    public module: any = null;
    public template: any = { scale: 7, categories: [], stages: ['seed','early','growth','mature'], stage_labels: {seed:'예비',early:'초기',growth:'도약',mature:'성숙'} };
    public applications: any[] = [];
    public mentors: any[] = [];
    public assignments: any[] = [];
    public assignmentSelect: any = {};
    public assignmentBulkEditing: boolean = false;
    public assignmentSaving: boolean = false;
    public showAssignmentRequestEditor: boolean = false;
    public assignmentRequestTarget: any = null;
    public assignmentRequestForm: any = this._emptyAssignmentRequest();
    public moduleAssignmentRequest: any = this._emptyAssignmentRequest();
    public moduleAssignmentRequestSaving: boolean = false;
    public responses: any[] = [];
    public summary: any = null;
    public aiRunning: boolean = false;

    public tab: string = 'questions'; // questions | settings | assignments | applicants | results
    public selectedAppId: string = '';
    public selectedApp: any = null;
    public formType: 'self' | 'expert' | 'ai' = 'self';
    public form: any = { items: [], overall_comment: '', evaluator_name: '', evaluator_user_id: '' };

    // 질문지 편집 탭에서 현재 보고/편집 중인 단계
    public editStage: string = 'seed';
    // 신청기업 진단시 자동판정/수동설정 단계
    public appStageAuto: string = 'early';
    public appStage: string = 'early';
    // 모듈 설정: 단계 모드(auto: 설립일 자동 / fixed: 단일 단계 고정)
    public settings: { stage_mode: 'auto'|'fixed', fixed_stage: string } = { stage_mode: 'auto', fixed_stage: 'early' };
    public savingSettings: boolean = false;
    public stageList: Array<{key:string,label:string}> = [
        { key: 'seed',   label: '예비 (창업 이전)' },
        { key: 'early',  label: '초기 (3년 이내)' },
        { key: 'growth', label: '도약 (3년 이상 7년 미만)' },
        { key: 'mature', label: '성숙 (7년 이후)' },
    ];

    public typeMeta: any = {
        self:   { label: '기업 자가진단', color: '#3b82f6', cls: 'text-blue-700 bg-blue-50' },
        expert: { label: '전문가 진단',   color: '#10b981', cls: 'text-emerald-700 bg-emerald-50' },
        ai:     { label: 'AI 진단',       color: '#f59e0b', cls: 'text-amber-700 bg-amber-50' },
    };

    public assignmentRoles = [
        { key: 'mentor', label: '멘토 배정' },
        { key: 'manager', label: '담당자 배정' },
    ];

    // SVG hex
    public hexSize: number = 220;
    public hexCenter: number = 230;

    public scaleOptions: number[] = [3, 4, 5, 6, 7, 8, 9, 10];
    public xlsxImporting: boolean = false;

    public scaleArray(): number[] {
        const n = Number(this.template?.scale) || 7;
        const arr: number[] = [];
        for (let i = 1; i <= n; i++) arr.push(i);
        return arr;
    }

    public async ngOnInit() {
        await this.service.init();
        if (this.module_id) await this.reload();
    }

    public async ngOnChanges() {
        if (this.module_id) await this.reload();
    }

    private async reload() {
        this.loaded = false;
        await this.service.render();
        const r = await wiz.call('get_module', { module_id: this.module_id });
        if (r.code != 200) {
            this.service.alert.show({ title: '오류', message: r.data?.message || '모듈 로드 실패', action: '확인' });
            return;
        }
        this.module = r.data.data;
        // 모듈 설정 로드 (config.stage_mode / config.fixed_stage)
        const cfg = (this.module && this.module.config) || {};
        this.moduleAssignmentRequest = this._normalizeAssignmentRequest(cfg.assignment_request);
        this.settings = {
            stage_mode: (cfg.stage_mode === 'fixed') ? 'fixed' : 'auto',
            fixed_stage: ['seed','early','growth','mature'].indexOf(cfg.fixed_stage) >= 0 ? cfg.fixed_stage : 'early',
        };
        await this.loadTemplate();
        await this.loadApplications();
        await this.loadMentors();
        await this.loadAssignments();
        this.loaded = true;
        await this.service.render();
    }

    public async loadTemplate() {
        const r = await wiz.call('get_template', { module_id: this.module_id });
        if (r.code == 200) this.template = r.data.data || { scale: 7, categories: [] };
        await this.service.render();
    }

    public async loadApplications() {
        const r = await wiz.call('list_applications', { program_id: this.program_id, module_id: this.module_id });
        if (r.code == 200) this.applications = r.data.rows || [];
        await this.service.render();
    }

    public async loadMentors() {
        const r = await wiz.call('list_mentors', { program_id: this.program_id, module_id: this.module_id });
        if (r.code == 200) this.mentors = r.data.rows || [];
        await this.service.render();
    }

    public async loadAssignments() {
        const r = await wiz.call('list_assignments', { program_id: this.program_id, module_id: this.module_id });
        if (r.code == 200) {
            this.assignments = r.data.rows || [];
            this._syncAssignmentSelect();
        }
        await this.service.render();
    }

    private _roleMatches(assignment: any, role: string): boolean {
        const r = assignment?.role || 'mentor';
        if (role === 'mentor') return ['mentor', 'primary', 'secondary'].indexOf(r) >= 0;
        return r === role;
    }

    private _assignmentKey(appId: string, role: string): string {
        return `${appId}:${role}`;
    }

    private _syncAssignmentSelect(force: boolean = false) {
        if (this.assignmentBulkEditing && !force) return;
        const next: any = {};
        for (const app of (this.applications || [])) {
            for (const role of this.assignmentRoles) {
                const key = this._assignmentKey(app.id, role.key);
                const ass = this.assignmentFor(app.id, role.key, false);
                next[key] = ass?.mentor_user_id || '';
            }
        }
        this.assignmentSelect = next;
    }

    public assignmentFor(appId: string, role: string, includePending: boolean = true): any {
        const rows = (this.assignments || []).filter((a: any) => a.application_id === appId && this._roleMatches(a, role));
        if (rows.length === 0) return null;
        const key = this._assignmentKey(appId, role);
        if (includePending && Object.prototype.hasOwnProperty.call(this.assignmentSelect, key)) {
            const selected = this.assignmentSelect[key] || '';
            const matched = rows.find((a: any) => a.mentor_user_id === selected);
            if (matched) return matched;
        }
        return rows[0];
    }

    public assignmentValue(appId: string, role: string): string {
        const key = this._assignmentKey(appId, role);
        if (Object.prototype.hasOwnProperty.call(this.assignmentSelect, key)) {
            return this.assignmentSelect[key] || '';
        }
        return this.assignmentFor(appId, role, false)?.mentor_user_id || '';
    }

    public assignmentMeta(appId: string, role: string): string {
        const selected = this.assignmentValue(appId, role);
        const ass = this.assignmentFor(appId, role);
        if (ass && (!selected || ass.mentor_user_id === selected)) {
            return [ass.mentor_email, ass.role_label].filter((x: any) => !!x).join(' · ');
        }
        return this.mentorSubText(selected);
    }

    public assignmentName(appId: string, role: string): string {
        const selected = this.assignmentValue(appId, role);
        return selected ? this.mentorName(selected) : '미배정';
    }

    private _emptyAssignmentRequest() {
        return { documents: '', note: '' };
    }

    private _normalizeAssignmentRequest(req: any): any {
        return {
            documents: req?.documents || req?.request_documents || '',
            note: req?.note || req?.request_note || '',
            title: req?.title || req?.request_title || '',
        };
    }

    private _hasRequest(req: any): boolean {
        return !!((req?.documents || '').trim() || (req?.note || '').trim() || (req?.title || '').trim());
    }

    public assignmentRequest(appId: string, role: string): any {
        const ass = this.assignmentFor(appId, role);
        const req = ass?.assignment_request || ass?.extra?.assignment_request || {};
        const normalized = this._normalizeAssignmentRequest(req);
        return this._hasRequest(normalized) ? normalized : { ...this.moduleAssignmentRequest };
    }

    public hasAssignmentRequest(appId: string, role: string): boolean {
        const req = this.assignmentRequest(appId, role);
        return !!((req.documents || '').trim() || (req.note || '').trim());
    }

    public assignmentRequestSummary(appId: string, role: string): string {
        const req = this.assignmentRequest(appId, role);
        const docs = String(req.documents || '').split('\n').map((v: string) => v.trim()).filter(Boolean);
        if (docs.length > 0) return `요청서류 ${docs.length}건`;
        if ((req.note || '').trim()) return '요청사항 있음';
        return '요청 없음';
    }

    public moduleAssignmentRequestSummary(): string {
        const docs = String(this.moduleAssignmentRequest?.documents || '').split('\n').map((v: string) => v.trim()).filter(Boolean);
        if (docs.length > 0) return `요청서류 ${docs.length}건`;
        if ((this.moduleAssignmentRequest?.note || '').trim()) return '요청사항 있음';
        return '요청 없음';
    }

    public async saveModuleAssignmentRequest() {
        if (this.moduleAssignmentRequestSaving) return;
        this.moduleAssignmentRequestSaving = true;
        await this.service.render();
        try {
            const r = await wiz.call('update_assignment_request', {
                module_id: this.module_id,
                request: JSON.stringify(this.moduleAssignmentRequest || {}),
            });
            if (r.code != 200) {
                this.service.alert.show({ title: '저장 실패', message: r.data?.message || '공통 요청자료 저장 중 오류가 발생했습니다.', action: '확인' });
                return;
            }
            const result = r.data?.result || {};
            this.moduleAssignmentRequest = this._normalizeAssignmentRequest(result.request || this.moduleAssignmentRequest);
            if (this.module?.config) this.module.config.assignment_request = { ...this.moduleAssignmentRequest };
            await this.loadAssignments();
            this.service.alert.show({ title: '저장 완료', message: `현재 배정 ${result.updated || 0}건에 반영했습니다.`, action: '확인' });
        } finally {
            this.moduleAssignmentRequestSaving = false;
            await this.service.render();
        }
    }

    public openAssignmentRequestEditor(app: any, role: string) {
        const userId = this.assignmentValue(app.id, role);
        if (!userId) {
            this.service.alert.show({ title: '배정 필요', message: '먼저 멘토/담당자를 배정하세요.', action: '확인' });
            return;
        }
        this.assignmentRequestTarget = { app, role };
        this.assignmentRequestForm = { ...this.assignmentRequest(app.id, role) };
        this.showAssignmentRequestEditor = true;
        this.service.render();
    }

    public closeAssignmentRequestEditor() {
        this.showAssignmentRequestEditor = false;
        this.assignmentRequestTarget = null;
        this.assignmentRequestForm = this._emptyAssignmentRequest();
        this.service.render();
    }

    public async saveAssignmentRequest() {
        const target = this.assignmentRequestTarget;
        if (!target?.app || !target.role) return;
        const userId = this.assignmentValue(target.app.id, target.role);
        if (!userId) {
            this.service.alert.show({ title: '배정 필요', message: '먼저 멘토/담당자를 배정하세요.', action: '확인' });
            return;
        }
        const r = await wiz.call('assign_mentor', {
            program_id: this.program_id,
            module_id: this.module_id,
            application_id: target.app.id,
            mentor_user_id: userId,
            role: target.role,
            request: JSON.stringify(this.assignmentRequestForm || {}),
        });
        if (r.code != 200) {
            this.service.alert.show({ title: '저장 실패', message: r.data?.message || '요청사항 저장 중 오류가 발생했습니다.', action: '확인' });
            return;
        }
        this.closeAssignmentRequestEditor();
        await this.loadAssignments();
    }

    public mentorName(id: string): string {
        const m = (this.mentors || []).find((x: any) => x.id === id);
        return (m && m.name) || id || '-';
    }

    public mentorSubText(id: string): string {
        const m = (this.mentors || []).find((x: any) => x.id === id);
        if (!m) return '';
        return [m.affiliation, m.expertise].filter((x: any) => !!x).join(' · ');
    }

    public assignmentChanged(appId: string, role: string): boolean {
        const current = this.assignmentFor(appId, role, false)?.mentor_user_id || '';
        const selected = this.assignmentValue(appId, role) || '';
        return current !== selected;
    }

    public onAssignmentSelectChange(app: any, role: string, userId: string) {
        const key = this._assignmentKey(app.id, role);
        this.assignmentSelect[key] = userId || '';
    }

    public assignmentChangeCount(): number {
        let count = 0;
        for (const app of (this.applications || [])) {
            for (const role of this.assignmentRoles) {
                if (this.assignmentChanged(app.id, role.key)) count += 1;
            }
        }
        return count;
    }

    public startAssignmentBulkEdit() {
        this._syncAssignmentSelect(true);
        this.assignmentBulkEditing = true;
        this.service.render();
    }

    public cancelAssignmentBulkEdit() {
        this.assignmentBulkEditing = false;
        this._syncAssignmentSelect(true);
        this.service.render();
    }

    public async saveAssignmentBulk() {
        if (this.assignmentSaving) return;
        const changes: any[] = [];
        for (const app of (this.applications || [])) {
            for (const role of this.assignmentRoles) {
                if (!this.assignmentChanged(app.id, role.key)) continue;
                changes.push({ app, role: role.key, userId: this.assignmentValue(app.id, role.key) || '' });
            }
        }
        if (changes.length === 0) {
            this.assignmentBulkEditing = false;
            await this.service.render();
            return;
        }
        this.assignmentSaving = true;
        await this.service.render();
        let success = false;
        try {
            for (const item of changes) {
                const r = await wiz.call('assign_mentor', {
                    program_id: this.program_id,
                    module_id: this.module_id,
                    application_id: item.app.id,
                    mentor_user_id: item.userId || '',
                    role: item.role,
                    request: JSON.stringify({}),
                });
                if (r.code != 200) {
                    throw new Error(r.data?.message || '배정 저장 중 오류가 발생했습니다.');
                }
            }
            success = true;
        } catch (e: any) {
            this.service.alert.show({ title: '배정 실패', message: e?.message || String(e), action: '확인' });
            return;
        } finally {
            this.assignmentSaving = false;
            if (success) {
                this.assignmentBulkEditing = false;
                await this.loadAssignments();
            } else {
                await this.service.render();
            }
        }
    }

    public async unassignMentor(assignment: any) {
        if (!confirm('이 멘토 배정을 해제하시겠습니까?')) return;
        const r = await wiz.call('unassign_mentor', { id: assignment.id });
        if (r.code != 200) {
            this.service.alert.show({ title: '해제 실패', message: r.data?.message || '오류', action: '확인' });
            return;
        }
        await this.loadAssignments();
    }

    public async selectApp(a: any) {
        this.selectedAppId = a.id;
        this.selectedApp = a;
        this.appStageAuto = this._detectStage(a);
        this.appStage = this.appStageAuto;
        await this.loadSummary();
        this._buildForm();
        await this.service.render();
    }

    public async onAppStageChange() {
        this._buildForm();
        await this.service.render();
    }

    private _detectStage(a: any): string {
        // 모듈 설정이 고정 모드면 설정된 단계 반환 (기업 설립일 무시)
        if (this.settings && this.settings.stage_mode === 'fixed') {
            return this.settings.fixed_stage || 'early';
        }
        if (!a) return 'seed';
        const extra = a.extra || {};
        if (['seed','early','growth','mature'].indexOf(extra.stage) >= 0) return extra.stage;
        const ds = extra.founded_at || extra.business_started_at || extra.established_at || a.founded_at || '';
        if (!ds) return 'seed';
        const m = String(ds).match(/(\d{4})[\-./]?(\d{1,2})?[\-./]?(\d{1,2})?/);
        if (!m) return 'seed';
        const y = parseInt(m[1]); const mo = parseInt(m[2] || '1'); const d = parseInt(m[3] || '1');
        const founded = new Date(y, mo - 1, d).getTime();
        if (isNaN(founded)) return 'seed';
        const years = (Date.now() - founded) / (365.25 * 24 * 3600 * 1000);
        if (years < 0) return 'seed';
        if (years < 3) return 'early';
        if (years < 7) return 'growth';
        return 'mature';
    }

    public stageLabel(s: string): string {
        const f = this.stageList.find(x => x.key === s);
        return f ? f.label : s;
    }

    private _buildForm() {
        const items: any[] = [];
        const stage = this.appStage || 'early';
        for (const cat of (this.template.categories || [])) {
            for (const it of (cat.items || [])) {
                const qtext = (it.questions && it.questions[stage]) || it.q || it.label || '';
                items.push({
                    cat: cat.key,
                    code: it.code || '',
                    label: it.label || qtext,
                    q: qtext,
                    score: 0,
                    comment: ''
                });
            }
        }
        this.form = {
            items,
            overall_comment: '',
            evaluator_name: '',
            evaluator_user_id: '',
        };
    }

    public async loadSummary() {
        if (!this.selectedAppId) return;
        const r = await wiz.call('summary', { module_id: this.module_id, application_id: this.selectedAppId });
        if (r.code == 200) this.summary = r.data.data;
        await this.service.render();
    }

    public setScore(idx: number, score: number) {
        this.form.items[idx].score = score;
    }

    public async saveDraft() {
        await this._submit('draft');
    }

    public async submitFinal() {
        if (!this._validate()) return;
        await this._submit('submitted');
    }

    private _validate(): boolean {
        const empty = (this.form.items || []).filter((it: any) => !it.score || it.score < 1).length;
        if (empty > 0) {
            this.service.alert.show({ title: '입력 필요', message: `${empty}개 항목의 점수가 누락되었습니다.`, action: '확인' });
            return false;
        }
        return true;
    }

    private async _submit(status: string) {
        if (!this.selectedAppId) return;
        const payload: any = {
            program_id: this.program_id,
            module_id: this.module_id,
            application_id: this.selectedAppId,
            type: this.formType,
            stage: this.appStage,
            items: this.form.items,
            overall_comment: this.form.overall_comment,
            status: status,
        };
        if (this.formType === 'expert') {
            payload.evaluator_user_id = this.form.evaluator_user_id || '';
            payload.evaluator_name = this.form.evaluator_name || '';
        }
        const r = await wiz.call('submit_response', { data: JSON.stringify(payload) });
        if (r.code != 200) {
            this.service.alert.show({ title: '저장 실패', message: r.data?.message || '오류', action: '확인' });
            return;
        }
        this.service.alert.show({ title: '완료', message: status === 'submitted' ? '진단이 제출되었습니다.' : '임시 저장되었습니다.', action: '확인' });
        await this.loadSummary();
        if (status === 'submitted') this._buildForm();
    }

    public async runAI() {
        if (!this.selectedAppId) return;
        if (this.aiRunning) return;
        const ok = await this.service.alert.show({
            title: 'AI 자동 진단',
            message: '신청서 데이터 기반의 휴리스틱 점수를 산정합니다.',
            action: '실행',
            actionBtn: 'success',
            cancel: '취소'
        });
        if (!ok) return;
        this.aiRunning = true;
        await this.service.render();
        try {
            const r = await wiz.call('run_ai', { module_id: this.module_id, application_id: this.selectedAppId });
            if (r.code != 200) {
                this.service.alert.show({ title: '실패', message: r.data?.message || '오류', action: '확인' });
                return;
            }
            this.service.alert.show({ title: '완료', message: 'AI 진단이 완료되었습니다.', action: '확인' });
            await this.loadSummary();
        } catch (e: any) {
            this.service.alert.show({ title: '실패', message: e?.message || String(e), action: '확인' });
        } finally {
            this.aiRunning = false;
            await this.service.render();
        }
    }

    // ===== 질문지 편집 =====
    public addCategory() {
        if (!this.template.categories) this.template.categories = [];
        const idx = this.template.categories.length + 1;
        const prefix = 'C';
        const newItem = this._makeBlankItem(prefix, 1, '새 질문');
        this.template.categories.push({ key: 'cat' + idx, label: '새 카테고리', items: [newItem] });
    }
    public removeCategory(i: number) {
        if (!confirm('카테고리를 삭제하시겠습니까?')) return;
        this.template.categories.splice(i, 1);
    }
    public addItem(ci: number) {
        const cat = this.template.categories[ci];
        const prefix = (cat.key || 'X').charAt(0).toUpperCase();
        const next = (cat.items?.length || 0) + 1;
        cat.items.push(this._makeBlankItem(prefix, next, '새 질문'));
    }
    private _makeBlankItem(prefix: string, idx: number, label: string): any {
        const pad = idx < 10 ? '0' + idx : String(idx);
        return {
            code: prefix + pad,
            label: label,
            q: label,
            questions: {
                seed:   `[예비] ${label} — 준비 수준은?`,
                early:  `[초기] ${label} — 확립 수준은?`,
                growth: `[도약] ${label} — 실행 수준은?`,
                mature: `[성숙] ${label} — 내재화 수준은?`,
            }
        };
    }
    public ensureItemStages(it: any) {
        if (!it.questions) it.questions = {};
        for (const s of ['seed','early','growth','mature']) {
            if (!it.questions[s]) it.questions[s] = '';
        }
        if (!it.label) it.label = it.q || '';
        if (!it.code) it.code = '';
    }
    public removeItem(ci: number, qi: number) {
        this.template.categories[ci].items.splice(qi, 1);
    }
    public async saveTemplate() {
        const r = await wiz.call('update_template', { module_id: this.module_id, data: JSON.stringify(this.template) });
        if (r.code != 200) {
            this.service.alert.show({ title: '저장 실패', message: r.data?.message || '오류', action: '확인' });
            return;
        }
        this.service.alert.show({ title: '완료', message: '질문지가 저장되었습니다.', action: '확인' });
        await this.loadTemplate();
    }

    // ===== 단계 설정 (운영별) =====
    public async saveSettings() {
        if (this.savingSettings) return;
        this.savingSettings = true;
        await this.service.render();
        try {
            const r = await wiz.call('update_settings', {
                module_id: this.module_id,
                stage_mode: this.settings.stage_mode,
                fixed_stage: this.settings.fixed_stage,
            });
            if (r.code != 200) {
                this.service.alert.show({ title: '저장 실패', message: r.data?.message || '오류', action: '확인' });
                return;
            }
            // 설정 변경 후 현재 선택된 기업의 단계 재산출
            if (this.selectedApp) {
                this.appStageAuto = this._detectStage(this.selectedApp);
                this.appStage = this.appStageAuto;
                this._buildForm();
            }
            this.service.alert.show({ title: '완료', message: '단계 설정이 저장되었습니다.', action: '확인' });
        } catch (e: any) {
            this.service.alert.show({ title: '오류', message: e?.message || String(e), action: '확인' });
        } finally {
            this.savingSettings = false;
            await this.service.render();
        }
    }

    public async onXlsxSelected(ev: any) {
        const file: File = ev?.target?.files?.[0];
        ev.target.value = '';
        if (!file) return;
        const ok = await this.service.alert.show({
            title: '엑셀 불러오기',
            message: `"${file.name}" 을(를) 읽어 현재 질문지를 교체합니다.\n(저장 버튼을 눌러야 적용됩니다)`,
            action: '진행', actionBtn: 'success', cancel: '취소'
        });
        if (!ok) return;
        this.xlsxImporting = true;
        await this.service.render();
        try {
            const fd = new FormData();
            fd.append('file', file);
            fd.append('scale', String(this.template.scale || 7));
            const res = await fetch(`/wiz/api/portal.lpsysadmin.support.module.diagnosis/import_xlsx`, {
                method: 'POST', body: fd, credentials: 'include',
            });
            const json = await res.json();
            if (res.ok && json?.data?.data) {
                const parsed = json.data.data;
                this.template = parsed;
                if (!this.template.categories) this.template.categories = [];
                this.service.alert.show({
                    title: '불러오기 완료',
                    message: `카테고리 ${parsed.categories.length}개, 총 ${parsed.categories.reduce((s:number,c:any)=>s+c.items.length,0)}개 질문을 인식했습니다.`,
                    action: '확인'
                });
            } else {
                this.service.alert.show({ title: '불러오기 실패', message: json?.data?.message || '엑셀 파싱 오류', action: '확인' });
            }
        } catch (e: any) {
            this.service.alert.show({ title: '불러오기 실패', message: e?.message || '네트워크 오류', action: '확인' });
        }
        this.xlsxImporting = false;
        await this.service.render();
    }

    // ===== Hex Radar SVG =====
    public hexPoints(scoreMap: any): string {
        const cats = this.template.categories || [];
        if (cats.length === 0) return '';
        const cx = this.hexCenter, cy = this.hexCenter;
        const r = this.hexSize;
        const max = this.template.scale || 7;
        const pts: string[] = [];
        const n = cats.length;
        for (let i = 0; i < n; i++) {
            const v = Number(scoreMap[cats[i].key] || 0);
            const ratio = Math.max(0, Math.min(1, v / max));
            const angle = -Math.PI / 2 + (i * 2 * Math.PI / n);
            const x = cx + Math.cos(angle) * r * ratio;
            const y = cy + Math.sin(angle) * r * ratio;
            pts.push(`${x.toFixed(1)},${y.toFixed(1)}`);
        }
        return pts.join(' ');
    }

    public hexAxisPoints(): string {
        const cats = this.template.categories || [];
        const cx = this.hexCenter, cy = this.hexCenter;
        const r = this.hexSize;
        const pts: string[] = [];
        const n = cats.length || 6;
        for (let i = 0; i < n; i++) {
            const angle = -Math.PI / 2 + (i * 2 * Math.PI / n);
            const x = cx + Math.cos(angle) * r;
            const y = cy + Math.sin(angle) * r;
            pts.push(`${x.toFixed(1)},${y.toFixed(1)}`);
        }
        return pts.join(' ');
    }

    public hexGridPolygons(): string[] {
        const cats = this.template.categories || [];
        const out: string[] = [];
        const n = cats.length || 6;
        const cx = this.hexCenter, cy = this.hexCenter;
        const r = this.hexSize;
        for (const ratio of [0.25, 0.5, 0.75, 1.0]) {
            const pts: string[] = [];
            for (let i = 0; i < n; i++) {
                const angle = -Math.PI / 2 + (i * 2 * Math.PI / n);
                pts.push(`${(cx + Math.cos(angle) * r * ratio).toFixed(1)},${(cy + Math.sin(angle) * r * ratio).toFixed(1)}`);
            }
            out.push(pts.join(' '));
        }
        return out;
    }

    public hexLabelPos(i: number): { x: number, y: number, anchor: string } {
        const cats = this.template.categories || [];
        const cx = this.hexCenter, cy = this.hexCenter;
        const r = this.hexSize + 22;
        const n = cats.length || 6;
        const angle = -Math.PI / 2 + (i * 2 * Math.PI / n);
        const x = cx + Math.cos(angle) * r;
        const y = cy + Math.sin(angle) * r;
        let anchor = 'middle';
        if (Math.cos(angle) > 0.3) anchor = 'start';
        else if (Math.cos(angle) < -0.3) anchor = 'end';
        return { x, y, anchor };
    }

    public typeLabel(t: string): string { return this.typeMeta[t]?.label || t; }
    public typeColor(t: string): string { return this.typeMeta[t]?.color || '#999'; }
    public typeCls(t: string): string { return this.typeMeta[t]?.cls || ''; }

    public scoreFor(t: string, catKey: string): string {
        const s = (this.summary?.scores?.[t]?.[catKey]);
        return (s == null || s === 0) ? '-' : Number(s).toFixed(1);
    }

    public hasScores(t: string): boolean {
        const map = this.summary?.scores?.[t];
        if (!map) return false;
        return Object.values(map).some((v: any) => Number(v) > 0);
    }
}

export default PortalLpsysadminSupportModuleDiagnosisComponent;